(() => {
  if (customElements.get('qeydo-comparator')) return;
  class QeydoComparator extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.products = JSON.parse(this.querySelector('[data-compare-products]').textContent);
      this.app = this.querySelector('[data-compare-app]');
      this.app.hidden = false;
      this.selected = this.products.slice(0, 2).map(p => p.id);
      this.onlyDifferences = false;
      this.products.forEach(p => {
        p.specs = new Map(Object.entries(p.fields));
        const add = (key, value) => {
          key = String(key || '').trim();
          value = String(value == null ? '' : value).trim();
          if (!key || !value) return;
          const match = [...p.specs.keys()].find(k => this.normalize(k) === this.normalize(key));
          if (match && !p.specs.get(match)) p.specs.set(match, value);
          else if (!match) p.specs.set(key, value);
        };
        String(p.technical || '').split(/\r?\n/).forEach(line => {
          const split = line.indexOf('|');
          if (split > 0) add(line.slice(0, split), line.slice(split + 1));
        });
        (p.characteristicNames || []).forEach((name, i) => add(name, (p.characteristicValues || [])[i]));
      });
      this.app.addEventListener('change', event => {
        if (event.target.matches('[data-model]')) {
          this.selected[Number(event.target.dataset.model)] = event.target.value;
          this.render();
          this.app.querySelector(`[data-model="${Number(event.target.dataset.model)}"]`)?.focus({preventScroll: true});
        } else if (event.target.matches('[data-differences]')) {
          this.onlyDifferences = event.target.checked;
          this.renderTable();
        }
      });
      this.app.addEventListener('click', event => {
        if (event.target.closest('[data-add]')) {
          const next = this.products.find(p => !this.selected.includes(p.id));
          if (next && this.selected.length < 3) this.selected.push(next.id);
          this.render();
        }
        const remove = event.target.closest('[data-remove]');
        if (remove && this.selected.length > 2) {
          this.selected.splice(Number(remove.dataset.remove), 1);
          this.render();
        }
      });
      this.render();
    }
    normalize(value) { return String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('fr').replace(/\s+/g, ' ').trim(); }
    node(tag, text, className) {
      const n = document.createElement(tag);
      if (text != null) n.textContent = text;
      if (className) n.className = className;
      return n;
    }
    render() {
      const previousScroll = this.viewport ? this.viewport.scrollLeft : 0;
      this.app.replaceChildren();
      if (this.products.length < 2) {
        this.app.append(this.node('p', 'Le comparateur sera disponible dès que deux modèles seront présents dans la collection. Consultez les fiches produits pour retrouver leurs caractéristiques.'));
        return;
      }
      const controls = this.node('div', null, 'qcompare-controls');
      this.selected.forEach((id, i) => {
        const label = this.node('label', null, 'qcompare-selector');
        label.append(this.node('span', `Modèle ${i + 1}`));
        const select = this.node('select');
        select.dataset.model = i;
        this.products.forEach(p => {
          const option = this.node('option', p.name);
          option.value = p.id;
          option.selected = p.id === id;
          option.disabled = this.selected.includes(p.id) && p.id !== id;
          select.append(option);
        });
        const selectFrame = this.node('span', null, 'qcompare-select-frame');
        selectFrame.append(select); label.append(selectFrame);
        controls.append(label);
      });
      const tools = this.node('div', null, 'qcompare-tools');
      const toggleLabel = this.node('label', null, 'qcompare-toggle');
      const toggle = this.node('input');
      toggle.type = 'checkbox'; toggle.checked = this.onlyDifferences; toggle.dataset.differences = '';
      toggleLabel.append(toggle, this.node('span', 'Différences uniquement'));
      tools.append(toggleLabel);
      if (this.selected.length < 3 && this.products.length > 2) {
        const add = this.node('button', '+ Ajouter un modèle', 'button button--secondary');
        add.type = 'button'; add.dataset.add = ''; tools.append(add);
      }
      this.status = this.node('p', null, 'qcompare-status');
      this.status.setAttribute('role', 'status'); this.status.setAttribute('aria-live', 'polite');
      this.viewport = this.node('div', null, 'qcompare-viewport');
      this.viewport.tabIndex = 0;
      this.viewport.setAttribute('role', 'region');
      this.viewport.setAttribute('aria-label', 'Tableau comparatif des serrures, défilement horizontal disponible');
      this.app.append(controls, tools, this.status, this.node('p', 'Sur petit écran, faites défiler le tableau horizontalement.', 'qcompare-hint'), this.viewport);
      this.renderTable();
      this.viewport.scrollLeft = previousScroll;
    }
    renderTable() {
      const products = this.selected.map(id => this.products.find(p => p.id === id));
      const table = this.node('table');
      table.style.setProperty('--compare-model-count', String(products.length));
      const columns = this.node('colgroup');
      columns.append(this.node('col', null, 'qcompare-label-col'));
      products.forEach(() => columns.append(this.node('col')));
      table.append(this.node('caption', 'Comparaison des caractéristiques des serrures Qeydo', 'visually-hidden'));
      table.append(columns);
      const thead = this.node('thead'), headRow = this.node('tr');
      const first = this.node('th', 'Votre sélection'); first.scope = 'col'; headRow.append(first);
      products.forEach((p, i) => {
        const th = this.node('th'); th.scope = 'col';
        if (this.selected.length > 2) {
          const remove = this.node('button', 'Retirer', 'qcompare-remove');
          remove.type = 'button'; remove.dataset.remove = i; remove.setAttribute('aria-label', `Retirer ${p.name}`); th.append(remove);
        }
        if (p.image) {
          const img = this.node('img'); img.src = p.image; img.alt = p.name; img.width = 240; img.height = 240; img.loading = 'lazy'; th.append(img);
        }
        th.append(this.node('h3', p.name));
        const rating = Number(p.rating), count = Number(p.reviewCount);
        if (rating > 0 && rating <= 5 && Number.isInteger(count) && count > 0) {
          const reviews = this.node('a', null, 'qcompare-reviews');
          reviews.href = `${p.url}#qeydo-product-reviews-summary`;
          reviews.setAttribute('aria-label', `${p.name} : ${rating.toLocaleString('fr-MA')} sur 5, ${count} avis`);
          const star = this.node('span', '★', 'qcompare-review-star'); star.setAttribute('aria-hidden', 'true');
          reviews.append(star, this.node('strong', rating.toLocaleString('fr-MA', {maximumFractionDigits: 1})), this.node('span', `(${count} avis)`));
          th.append(reviews);
        }
        th.append(this.node('p', `${p.priceVaries ? 'À partir de ' : ''}${p.price}`, 'qcompare-price'));
        const link = this.node('a', 'Voir le modèle', 'button button--primary'); link.href = p.url; th.append(link);
        if (!p.available) th.append(this.node('small', 'Actuellement indisponible'));
        headRow.append(th);
      });
      thead.append(headRow); table.append(thead);
      const body = this.node('tbody');
      const labels = new Map();
      products.forEach(p => p.specs.forEach((v, k) => { if (!labels.has(this.normalize(k))) labels.set(this.normalize(k), k); }));
      let visible = 0, differences = 0;
      labels.forEach((label, key) => {
        const values = products.map(p => {
          const entry = [...p.specs].find(([k]) => this.normalize(k) === key);
          return entry && entry[1] ? String(entry[1]) : '';
        });
        if (!values.some(Boolean)) return;
        const differs = new Set(values.map(v => this.normalize(v))).size > 1;
        if (differs) differences++;
        if (this.onlyDifferences && !differs) return;
        visible++;
        const row = this.node('tr', null, differs ? 'qcompare-difference' : '');
        const th = this.node('th', label); th.scope = 'row'; row.append(th);
        values.forEach(value => row.append(this.node('td', value || 'Non renseigné')));
        body.append(row);
      });
      table.append(body); this.viewport.replaceChildren(table);
      this.status.textContent = `${products.length} modèles · ${differences} critères différents · ${visible} critères affichés`;
      if (!visible) this.viewport.append(this.node('p', 'Aucune différence renseignée pour cette sélection.'));
    }
  }
  customElements.define('qeydo-comparator', QeydoComparator);
})();
